module.exports = __webpack_public_path__ + "assets/images/passengers_phase5.887b4c72ee3010b0baaa67e011810731.svg";